import React from 'react';
import { Chip } from '@mui/material';

const OrderStatusChip = ({ value }) => {
    const color = value === 'DEBIT' ? '#D32F2F' : '#388E3C';

    return (
        <Chip
            label={value}
            variant="filled"
            size="medium"
            sx={{
                px: '6px',
                backgroundColor: color,
                color: '#fff',
                fontSize: '11px',
                fontFamily: "Be Vietnam Pro",
                fontWeight: 500,
            }}
        />
    );
};

export default OrderStatusChip;

